import React from "react";
import styled from "styled-components";
import FallbackImage from "../../assets/images/fallback/transparent_picture.png";

const Image = (props) => {
  return (
    <CustomImage
      {...props}
      height={props.height}
      width={props.width}
      src={props.src}
      alt={props.alt || "Image not found"}
      onError={(e) => {
        e.target.src = FallbackImage;
      }}
      style={props.style}
      className={props.className}
    >
      {props.children}
    </CustomImage>
  );
};

export const CustomImage = styled.img`
  height: 100%;
  width: 100%;
`;

export default Image;
